import { createTheme } from '@mui/material/styles';
import { alpha } from '@mui/material';

const theme = createTheme({
    components: {
        MuiDialog: {
            defaultProps: {
                BackdropProps: {
                    sx: {
                        backdropFilter: 'blur(6px)',
                        backgroundColor: (theme) => alpha(theme.palette.common.black, 0.4),
                    },
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    backgroundColor: 'color-mix(in srgb, var(--button-background-color) 15%, transparent)',
                },
                bar: {
                    backgroundColor: 'var(--button-background-color)',
                },
            },
        },
    },
});

export default theme;